import * as React from 'react'
import { FC, useEffect, useRef, useState } from 'react'
import * as styles from './ColoredSVG.module.scss'

interface IProps {
  url: string
  className?: string
  width?: number
  height?: number
  maxWidth?: number
  maxHeight?: number
}

const getMeta = (url: string) => {
  return new Promise<HTMLImageElement>((resolve, reject) => {
    const img = new Image()
    img.onload = () => resolve(img)
    img.onerror = () => reject()
    img.src = url
  })
}

const ColoredSVG: FC<IProps> = (props) => {
  const [height, changeHeight] = useState(props.height)
  const [width, changeWidth] = useState(props.width)
  const mountedRef = useRef(true)

  useEffect(() => {
    return () => {
      mountedRef.current = false
    }
  }, [])

  const { url, className, maxHeight, maxWidth } = props

  getMeta(url)
    .then((data) => {
      if (!mountedRef.current) return
      if (!height) changeHeight(data.naturalHeight || props.maxWidth)
      if (!width) changeWidth(data.naturalWidth || props.maxHeight)
    })
    .catch(() => console.error(`SVG not found ${url}`))

  const classes = [styles.block, className ? className : '']

  return (
    <div
      className={classes.join(' ')}
      style={{
        width,
        height,
        maxWidth,
        maxHeight,
        maskImage: `url(${url})`,
        WebkitMaskImage: `url(${url})`,
      }}
    />
  )
}

export default ColoredSVG
